import type { ReactNode } from "react";
import { DatasetDetailWindowContent } from "@/modules/datasets/public";
import { WindowStackHost, type WindowEntry } from "@/shared/ui/window";
import { windowStack, type WindowKind } from "../shell/windowStack";

type WindowContentProps = { entry: WindowEntry; active: boolean };

// kind → 콘텐츠 컴포넌트 레지스트리. 제네릭 호스트는 kind 를 모르고, 이 앱 호스트만 매핑을 안다.
// 창 콘텐츠는 각 모듈의 public 표면에서 가져온다.
const WINDOW_REGISTRY: Record<WindowKind, (props: WindowContentProps) => ReactNode> = {
  datasetDetail: DatasetDetailWindowContent,
};

// 앱 스코프 전체화면 창 호스트. 라우터(`AppRoot` 의 data router) 안에 마운트해, 최소화한 창이 화면 전환에도
// 유지·복원되고 콘텐츠가 useNavigate 등 라우터 훅을 쓸 수 있게 한다. 제네릭 WindowStackHost 에
// 앱 스택과 레지스트리(renderWindow)를 주입한다.
export function AppWindowHost(): ReactNode {
  return (
    <WindowStackHost
      stack={windowStack}
      renderWindow={(entry, active) => {
        const Content = WINDOW_REGISTRY[entry.kind as WindowKind];
        return Content !== undefined ? <Content entry={entry} active={active} /> : null;
      }}
    />
  );
}
